export default "__VITE_ASSET__0580eaa2__"